import { useLanguage } from '../components/LanguageContext'
import { webinarCopy, webinarSessions, type WebinarLang } from '../data/webinarCommunications'

/** Webinar copy + session for the active site language. Switching session switches the page language. */
export function useWebinar() {
  const { lang, setLang } = useLanguage()
  const current: WebinarLang = lang === 'EN' ? 'EN' : 'FR'
  const otherLang: WebinarLang = current === 'FR' ? 'EN' : 'FR'
  return {
    lang: current,
    copy: webinarCopy[current],
    session: webinarSessions[current],
    otherSession: webinarSessions[otherLang],
    switchSession: () => setLang(otherLang),
    setLang,
  }
}
